import styles from './Layout.module.css'

export function PageToolbar({ search, filters, viewControls, sort, batchActions, actions, label = 'Page controls', className = '' }) {
  return (
    <section className={`${styles.toolbar} ${className}`.trim()} aria-label={label}>
      {search ? <div className={styles.toolbarSearch}>{search}</div> : null}
      {filters ? <div className={styles.toolbarFilters}>{filters}</div> : null}
      {viewControls ? <div className={styles.toolbarViews}>{viewControls}</div> : null}
      {sort ? <div className={styles.toolbarSort}>{sort}</div> : null}
      {actions ? <div className={styles.toolbarActions}>{actions}</div> : null}
      {batchActions ? <div className={styles.toolbarBatch}>{batchActions}</div> : null}
    </section>
  )
}
